import { useRef, useState, useEffect } from 'react'
import { RichContent } from '@corratech/pylot-rich-content'
import s from './ReadMore.module.scss'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'

const LINES_TO_DISPLAY = 2
const LINE_HEIGHT = 21.6

type ReadMoreProps = {
    className?: string
    content: string
}

export const ReadMore = ({ className, content }: ReadMoreProps) => {
    const ageVerificationMessageRef = useRef<HTMLDivElement>(null)
    const messageHtml = ageVerificationMessageRef.current?.querySelector('p')
    const [showReadMore, setShowReadMore] = useState(true)
    const [showButton, setShowButton] = useState(false)
    const { t } = useTranslation(['pdp'])
    useEffect(() => {
        if (messageHtml) {
            const divHeight = messageHtml?.offsetHeight
            if (divHeight && divHeight / LINE_HEIGHT > LINES_TO_DISPLAY)
                setShowButton(true)
        }
    }, [messageHtml])

    const handleButton = () => {
        setShowReadMore(!showReadMore)
    }

    if (!content) return null

    return (
        <div
            className={cn(
                className,
                showButton && showReadMore
                    ? cn(s['read-more-message-hide'], 'pdp-description')
                    : cn(s['less-pdp-msg'], 'pdp-description')
            )}
            ref={ageVerificationMessageRef}
        >
            <p>
                <RichContent html={content} />
            </p>
            {showButton && (
                <button
                    className={cn(
                        s['read-more-button'],
                        'btn-link pdp-read-more'
                    )}
                    onClick={handleButton}
                >
                    {showReadMore ? t('more') : t('less')}
                </button>
            )}
        </div>
    )
}
